(() => {
  const FREE_GIFT_VARIANT_ID = 50754349007080;

  const QUALIFYING_PRODUCT_IDS = [
    9523221430504, // Shoulder Neck Massager
    9097246671080, // Duo Support Bundle
    9097193259240  // Full Set Bundle
  ];

  let updating = false;
  let syncTimer = null;

  // 保存 Shopify 原本的 fetch
  const originalFetch = window.fetch.bind(window);

  async function getCart() {
    const response = await originalFetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    return response.json();
  }

  async function syncFreeGift() {
    if (updating) return;

    try {
      const cart = await getCart();

      const hasQualifyingProduct = cart.items.some(item =>
        QUALIFYING_PRODUCT_IDS.includes(Number(item.product_id))
      );

      const giftItems = cart.items.filter(
        item => Number(item.variant_id) === FREE_GIFT_VARIANT_ID
      );

      const giftItem = giftItems[0];

      // 有资格产品 + 没有赠品 = 加 1 个
      if (hasQualifyingProduct && !giftItem) {
        updating = true;

        const response = await originalFetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: FREE_GIFT_VARIANT_ID,
                quantity: 1
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error('Unable to add free gift');
        }

        updating = false;

        // 刷新页面，让 Cart Drawer 正确显示赠品和折扣
        window.location.reload();
        return;
      }

      // 没有资格产品 + 有赠品 = 删除赠品
      if (!hasQualifyingProduct && giftItem) {
        updating = true;

        for (const item of giftItems) {
          await originalFetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
        }

        updating = false;
        window.location.reload();
        return;
      }

      // 有资格产品，但赠品数量超过 1 = 强制变回 1
      if (
        hasQualifyingProduct &&
        giftItem &&
        giftItem.quantity > 1
      ) {
        updating = true;

        await originalFetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 1
          })
        });

        updating = false;
        window.location.reload();
      }

    } catch (error) {
      console.error('Dr Chiro Free Gift Error:', error);
      updating = false;
    }
  }

  function scheduleGiftSync() {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(() => {
      syncFreeGift();
    }, 500);
  }

  // 监听 Shopify 真正的购物车请求
  window.fetch = async function (...args) {
    const response = await originalFetch(...args);

    const request = args[0];

    const url =
      typeof request === 'string'
        ? request
        : request && request.url
        ? request.url
        : '';

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update')
    ) {
      scheduleGiftSync();
    }

    return response;
  };

  // 页面第一次打开时检查
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scheduleGiftSync();
    });
  } else {
    scheduleGiftSync();
  }
})();